export class SelectOptionsHelper {
    static EventTypes = [
        { id: "unique", label: "Único" },
        { id: "recurrent-weekly", label: "Semanal" },
        { id: "recurrent-monthly", label: "Mensal" },
        { id: "recurrent-yearly", label: "Anual" },
    ];

    static WeekDays = [
        { id: 0, label: "Domingo" },
        { id: 1, label: "Segunda-Feira" },
        { id: 2, label: "Terça-Feira" },
        { id: 3, label: "Quarta-Feira" },
        { id: 4, label: "Quinta-Feira" },
        { id: 5, label: "Sexta-Feira" },
        { id: 6, label: "Sábado" },
    ];

    static Months = [
        { id: 1, label: "Janeiro" },
        { id: 2, label: "Fevereiro" },
        { id: 3, label: "Março" },
        { id: 4, label: "Abril" },
        { id: 5, label: "Maio" },
        { id: 6, label: "Junho" },
        { id: 7, label: "Julho" },
        { id: 8, label: "Agosto" },
        { id: 9, label: "Setembro" },
        { id: 10, label: "Outubro" },
        { id: 11, label: "Novembro" },
        { id: 12, label: "Dezembro" },
    ];

    static PathOrientations = [
        { orientation: 'G', label: "Ida" },
        { orientation: 'R', label: "Volta" },
        { orientation: 'C', label: "Circular" },
    ];

    static FareProductState = [
        { value: 0, label: "Ativo" },
        { value: 1, label: "Inativo" },
    ];

    static PointOfInterestTypes = [
        { value: 0, label: "Não definido" },
        { value: 1, label: "Bilheteira" },
        { value: 2, label: "Aluguer de bicicletas" },
        { value: 3, label: "Aluguer de trotinetes" },
        { value: 4, label: "Aluguer de barcos" },
        { value: 5, label: "Parque de bicicletas" },
        { value: 6, label: "Carregamento eléctrico" }
    ]
}



// WEBPACK FOOTER //
// ./src/components/helpers/SelectOptionsHelper.js